import React from 'react'
import "./Title.css"

const Title = ({ title, color, overlay, overlayColor }) => {
    return (
        <div className='main-title-container' >
            <h1 
                className='main-title' 
                style={{ color: `${color ? color : "var(--main-color)"}` }}
            >
                {title}
            </h1>
            <div 
                className='main-title-overlay'
                style={{ color: `${overlayColor ? overlayColor : "var(--main-color)"}` }}    
            >
                {overlay}
            </div>
        </div>
    )
}

export default Title
